import request from "@/utils/request";

export default function agentGetOwnDetails() {
    return request({
        url: `/user/agent/agentGetOwnDetails`,
    })
}
